"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CertificateCard = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = __importStar(require("styled-components"));
var StyledCerificateCard = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  border-radius: ", "px;\n  padding: 15px;\n  .title-wrapper {\n    margin-bottom: 49px;\n  }\n  .title-wrapper,\n  .date-wrapper {\n    &__uptitle {\n      margin-bottom: 6px;\n    }\n  }\n"], ["\n  background-color: ", ";\n  border-radius: ", "px;\n  padding: 15px;\n  .title-wrapper {\n    margin-bottom: 49px;\n  }\n  .title-wrapper,\n  .date-wrapper {\n    &__uptitle {\n      margin-bottom: 6px;\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.buttonRadius;
});
var CertificateCard = function (_a) {
    var uptitle = _a.uptitle, title = _a.title, dateUptitle = _a.dateUptitle, date = _a.date, actions = _a.actions;
    return ((0, jsx_runtime_1.jsxs)(StyledCerificateCard, __assign({ className: "certificate-card" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "title-wrapper" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "title-wrapper__uptitle" }, { children: uptitle })), title] })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "date-wrapper" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "title-wrapper__uptitle" }, { children: dateUptitle })), date] })), actions] })));
};
exports.CertificateCard = CertificateCard;
var NewCertificateCard = (0, styled_components_1.default)(exports.CertificateCard)(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
exports.default = (0, styled_components_1.withTheme)(NewCertificateCard);
var templateObject_1, templateObject_2;
